import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { User } from '../../../../../models/entities/user';
import { FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { PropertyManagementCompanyService } from '../../../../../services/property-management-company/property-management-company.service';
import { PropertyManagementCompanyDataService } from '../../../../../services/property-management-company/property-manager-company-data.service';
import { filter, startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnimatedDirective } from '../../../shared/directives/animated.directive';
import { CardNestedCardDirective } from '../../../shared/cards/card.directive';
import { LegfiPhonePipeModule } from '../../../../../pipes/format/legfi-phone.module';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatOptionModule } from '@angular/material/core';
import { NgForOf, NgIf } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { AvatarBlockModule } from '../../../shared/avatar-block/avatar-block.module';
import { I18nMap } from '../../../../../models/entities/i18n-map';

@UntilDestroy()
@Component({
    selector: 'app-team-member-search',
    templateUrl: './team-member-search.component.html',
    standalone: true,
    imports: [
        AnimatedDirective,
        CardNestedCardDirective,
        FormsModule,
        LegfiPhonePipeModule,
        MatAutocompleteModule,
        MatCardModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatOptionModule,
        NgForOf,
        ReactiveFormsModule,
        NgIf,
        AvatarBlockModule,
    ],
})
export class TeamMemberSearchComponent implements OnInit
{
    @Input() cardTitle = 'Add existing team member';
    @Output() teamMemberSelected = new EventEmitter<User>();
    @Output() teamMembersLoaded = new EventEmitter<User[]>();
    @ViewChild(MatAutocompleteTrigger) autoTrigger: MatAutocompleteTrigger;

    searchControl = this._fb.control('');
    selectedEmails = new SelectionModel<string>(true);
    teamMembers: User[] = [];

    readonly organizationsMapping: I18nMap = {
        '=0': 'No organizations',
        '=1': '1 organization',
        other: '# organizations',
    };
    readonly itemHeight = 58;

    constructor(
            private _fb: NonNullableFormBuilder,
            private _propertyManagementCompanyService: PropertyManagementCompanyService,
            private _propertyManagementCompanyData: PropertyManagementCompanyDataService,
    ) {
    }

    get pmcId()  {
        return this._propertyManagementCompanyData.pmcId;
    }

    get filteredTeamMembers() {
        return this.teamMembers.filter((user) => {
            const term = this.searchControl.value?.toString().toLowerCase();
            return user.name.toLowerCase().includes(term);
        });
    }

    ngOnInit() {
        this.setupSearch();
    }

    private setupSearch() {
        if (this.pmcId) {
            this._propertyManagementCompanyService.getPropertyManagementTeamMembers(this.pmcId).pipe(
                    untilDestroyed(this),
            ).subscribe({
                next: (res) => {
                    this.teamMembers = res;
                    this.teamMembersLoaded.emit(this.teamMembers);
                },
            });
        }

        this.searchControl.valueChanges.pipe(
                startWith(''),
                filter((val) => typeof val === 'number'),
                map((val) => this.teamMembers.find((user) => user.id === +val)),
                untilDestroyed(this),
        ).subscribe({
            next: (user) => {
                this.searchControl.reset();
                this.selectedEmails.select(user.email);
                this.teamMemberSelected.emit(user);
            },
        });
    }
}
